module.exports = __webpack_public_path__ + "img/head@2x.d2f94868.png";